// extracted by mini-css-extract-plugin
export default {"root":"BuildingExternalDocumentModal__root--o6dEu"};